export const lsProps = {  
  token: "token",
};
